import {
  ActionList,
  ActionListItem,
  Box,
  DropdownOverlay,
  SelectInput,
  TableCell,
  TableEditableDropdownCell,
} from '@razorpay/blade/components';
import React from 'react';
import { SalaryStructureComponentValueTypeLabels } from '../constants';
import { useSalaryStructure } from '../context/SalaryStructureProvider';
import { SalaryStructureComponentProps, SalaryStructureComponentValueType } from '../types';

const isValueTypeEqual = (
  prevProps: SalaryStructureComponentProps,
  nextProps: SalaryStructureComponentProps,
) => {
  return (
    prevProps.item.valueType === nextProps.item.valueType &&
    prevProps.item.salaryComponent.id === nextProps.item.salaryComponent.id
  );
};

const TypeCell = ({ item }: SalaryStructureComponentProps) => {
  const type = item.valueType;
  const isSpecialAllowance =
    item.salaryComponent.componentType === 'COMPONENT_TYPE_SPECIAL_ALLOWANCE';

  const isTypeEditDisabled = isSpecialAllowance;

  const { updateType } = useSalaryStructure();

  if (isTypeEditDisabled) {
    return (
      <TableCell>
        <Box paddingX="spacing.2"></Box>
      </TableCell>
    );
  }

  const handleTypeChange = (value: SalaryStructureComponentValueType) => {
    updateType(item.id.toString(), value);
  };

  return (
    <TableEditableDropdownCell>
      <SelectInput
        label=""
        placeholder="Value Type"
        accessibilityLabel="Value Type"
        value={type}
        onChange={(e) => handleTypeChange(e.values[0] as SalaryStructureComponentValueType)}
      />
      <DropdownOverlay>
        <ActionList>
          {Object.entries(SalaryStructureComponentValueTypeLabels).map(([key, value]) => (
            <ActionListItem key={key} title={value.label} value={key} />
          ))}
        </ActionList>
      </DropdownOverlay>
    </TableEditableDropdownCell>
  );
};

TypeCell.displayName = 'TypeCell';

export default React.memo(TypeCell, isValueTypeEqual);
